const shipmentEndpoint = {
  fileUploadStatus: 'fileUploadStatus',
  getShipmentList: 'getshipmentlist',
  uploadFile: 'uploadfile',
  getShipment: 'getShipment',
  updateShipment: 'updateshipment',
  createShipment: 'createshipment',
  updateShipmentHistory: 'updateshipmenthistory',
  getPiecesList: 'getPiecesList',
  getUnlinkedPiecesList: 'getUnlinkedPiecesList',
  deleteShipment: 'deleteshipment',
  deleteShipmentBatch: 'deleteShipmentBatch',
  getShipmentListById: 'getShipmentListById', //Not Used
  getLbbxMAWBIds: 'getLbbxMAWBIds',
  lbbxLinkedShipmentList: 'lbbxLinkedShipmentList',
  babyLogs: 'baby/babyLogs',
  getManifestFailedShipment: 'getManifestFailedShipment',
  viewBabyFileData: 'viewBabyFileData',
  uploadCI: 'uploadCI',
  deleteUploadedCI: 'deleteUploadedCI',
};

const userEndpoint = {
  userLogin: 'login',
  userForgotPassword: 'forgotPassword',
  userSignUp: 'signup',
  customerRegistration: 'customerRegistration',
  userResetPassword: 'resetPassword',
  userChangePassword: 'changePassword',
  getAccessToken: 'getaccesstoken',
  getUserList: 'list',
  activateUser: 'activate',
  unLockUser: 'unLock',
  deleteUser: 'delete',
  assignUserRole: 'assignrole',
  refresh: 'refresh',
  logout: 'logout',
  customerList: 'customerList',
  loginBackup: 'loginBackup',
  cacheForCustomer: 'cacheForCustomer',
};

const mawbEndpoint = {
  createMawb: 'createMawb',
  getMawbList: 'mawblist',
  closeMawb: 'close',
  deleteMawb: 'delete',
  viewMawbFileData: 'viewMawbFileData',
  deleteUploadedCI: 'deleteUploadedCI',
  lbbxShipmentLink: 'lbbxShipmentLink',
  invoiceUpload: 'invoiceUpload',
  uploadCI: 'uploadCI',
  saveDGContent: 'saveDGContent',
  saveInvoice: 'saveInvoice',
  updatemawbCharges: 'updatemawbcharges',
  updatemawbInvoiceReference: 'updateMAWBInvoiceReference',
  updatemawbreference: 'updatemawbreference', 
};

const linkingEndpoint = {
  linkPieces: 'link',
  deLinkPieces: 'delink',
  managePallet: 'managepallet',
};

const babyProcessingEndpoint = {
  renderLabel: 'renderlabel',
  fetchLabel: 'fetchlabel',
  renderBatchLabel: 'renderBatchLabel',
  fetchBatchLabel: 'fetchBatchLabel',
  deletePath: 'deletePath',
  babyManifest: 'baby/babyManifest',
  individualBabyManifest: 'baby/babyManifest/individual',
};

const configEndpoint = {
  getConfiguration: 'getconfiguration',
  addConfiguration: 'addconfiguration',
  deleteConfiguration: 'deleteConfiguration',
  defaultConfiguration: 'getDefaultConfiguration',
};

const addressEndpoint = {
  getAddressList: 'list',
  updateAddress: 'update',
  importAddress: 'importAddress',
  createAddress: 'create',
  deleteAddress: 'delete',
  getPostalList: 'postallist',
  getAddressSheet: 'downloadSheetAddress',
};

const pickupEndPoint = {
  bookPickup: 'pickup/bookPickup',
  getPickupList: 'pickup/pickuplist',
  cancelPickup: 'pickup/cancelPickup',
};

const reportEndPoint = {
  getHeaders: 'report/getHeaders',
  getReport: 'report/getReport',
};

export {
  shipmentEndpoint,
  userEndpoint,
  mawbEndpoint,
  linkingEndpoint,
  babyProcessingEndpoint,
  configEndpoint,
  addressEndpoint,
  pickupEndPoint,
  reportEndPoint,
};
